// extracted by mini-css-extract-plugin
module.exports = {"titleColor":"MaterialCategory_titleColor__yuX11"};